import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core'

@Directive({
  selector: '[mbShowPopup]'
})
export class MbShowPopupDirective {

  constructor (private render: Renderer2, private el: ElementRef) { }

  @HostListener('click')
  private onClickShow () {
    this.render.addClass(this.el.nativeElement, 'mb-showPopup')
    const firstChildEl = this.el.nativeElement.childNodes[0]
    setTimeout(() =>
      {
        this.render.addClass(firstChildEl, 'fade-in')
      },
      100)
    setTimeout(() =>
      {
        this.render.removeClass(firstChildEl, 'fade-in')
      },
      2700)
    setTimeout(() =>
      {
        this.render.removeClass(this.el.nativeElement, 'mb-showPopup')
      },
      3000)
  }

}
